import {getGeneralDetails} from '@/services/Order/orderItemOverview'
import {useQueries} from '@tanstack/react-query'

export const useGeneralDetails = () => {
  const results = useQueries({
    queries: [{queryKey: ['ORDER_ITEM_OVERVIEW_GENERAL_DETAILS'], queryFn: getGeneralDetails}],
  })

  const {generalDetailsJsonSchema, generalDetailsUISchema} = results?.[0]?.data || {}

  return {
    generalDetailsJsonSchema,
    generalDetailsUISchema,
  }
}
